/**
 * Brand assets and small reusable brand components.
 * Logo image lives at /logo.png (public folder).
 */

export const BRAND = {
  name: "Citas Taller",
  tagline: "El gestor de citas para talleres mecánicos",
  domain: "citastallerapp.com",
  contactEmail: "info@citastallerapp.com",
  contactPhone: "690789005",
  contactPhoneIntl: "+34690789005",
  legal: {
    holder: "Julián Requena de Lamo",
    nif: "47091750D",
    address: "Calle Sagasta 37, 2º D",
    postalCode: "02630",
    city: "La Roda",
    province: "Albacete",
    country: "España",
    fullAddress: "Calle Sagasta 37, 2º D · 02630 La Roda (Albacete), España",
    lastUpdate: "24 de febrero de 2026",
  },
};

export function Logo({ size = 48, className = "" }) {
  return (
    <img
      src="/logo.png"
      alt="Citas Taller"
      width={size}
      height={size}
      className={`rounded-xl ${className}`}
      style={{ width: size, height: size, objectFit: "cover" }}
      data-testid="brand-logo"
    />
  );
}
